import { render, staticRenderFns } from "./DialogPrescriptionConfirm.vue?vue&type=template&id=61ad254f&scoped=true&"
import script from "./DialogPrescriptionConfirm.vue?vue&type=script&lang=js&"
export * from "./DialogPrescriptionConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DialogPrescriptionConfirm.vue?vue&type=style&index=0&id=61ad254f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad254f",
  null
  
)

export default component.exports